module.exports = __webpack_public_path__ + "img/qualities-bg1.fc447957.png";